// extracted by mini-css-extract-plugin
export default {"wrap":"sendMessageForm_wrap__pFiRM","sendBtn":"sendMessageForm_sendBtn__deACe"};